import { Api } from '@/services/Api'

const momentTz = require('moment-timezone')
import store from "@/store/index";

export default {
  fetchPlantTemplate(plantId) {
    return Api().get(`api/v2/advance-report/template/${plantId}`)
  },
  fetchPlantPrgtConfig(plantId) {
    return Api().get(`/api/v2/prgt/prgtConfig/${plantId}`)
  },
  fetchBlock(param) {
    return Api().post(`api/v2/advance-report/block`, param)
  },
  fetchEquipmentWiseDevice(param) {
    return Api().post(`api/v2/advance-report/equipment/device-config`, param)
  },
  fetchBlockEquipment(param) {
    return Api().post(`api/v2/advance-report/block/equipment`, param)
  },
  fetchBlockWiseDevice(param) {
    return Api().post(`api/v2/advance-report/block/equipment/device`, param)
  },
  fetchAllEquipments(param) {
    return Api().post(`api/v2/advance-report/equipment`, param)
  },
  fetchData(param) {
    return Api().post('/api/v2/advance-report', param, { timeout: 120000 })
  },
  fetchDeviceReport(param) {
    return Api().post('/api/v2/advance-report/device-report', param, { timeout: 120000 })
  },
  fetchPlantSummary(param) {
    return Api().post('/api/v2/advance-report/plant/summary', param, { timeout: 120000 })
  },
  fetchPlantPrgt(param) {
    return Api().post('/api/v2/advance-report/plant/prgt',param, { timeout: 120000 })
  },
  fetchPerformanceReport(param) {
    return Api().post('/api/v2/advance-report/device/performance', param, { timeout: 120000 })
  },
  fetchSlotWiseReportData(param) {
    return Api().post('api/v2/advance-report/device/slot', param, { timeout: 120000 })
  },
  downloadSlotReport(param, reportName) {
    return Api().request({
      url: '/api/v2/advance-report/slot/summary/' + param,
      method: 'GET',
      responseType: 'blob',
      timeout: 120000
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url

      link.setAttribute('download', `${reportName}-${momentTz().tz(store.getters.getGeneralState('activePlant').timezone).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`)
      link.click();
      window.URL.revokeObjectURL(url);
    })
  },
  async downloadDeviceReport(param, reportName) {
    try {
      const response = await Api().request({
        url: `/api/v2/advance-report/summary/${param}`,
        method: 'GET',
        responseType: 'blob',
        timeout: 120000
      });
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
  
      const timezone = store.getters.getGeneralState('activePlant').timezone;
      const timestamp = momentTz().tz(timezone).format('YYYY_MM_DD_HH_mm_ss');
      link.setAttribute('download', `${reportName}-${timestamp}.xlsx`);
  
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading report:', error);
    }
  },
  downloadPlantSummary(param, reportName) {
    return Api().request({
      url: '/api/v2/advance-report/plant/summary/' + param,
      method: 'GET',
      responseType: 'blob',
      timeout: 120000
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url

      link.setAttribute('download', `${reportName}-${momentTz().tz(store.getters.getGeneralState('activePlant').timezone).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`)
      link.click();
      window.URL.revokeObjectURL(url);
    })
  },
  downloadPlantPrgt(param, reportName) {
      return Api().request({
        url: '/api/v2/advance-report/plant/prgt/' + param,
        method: 'GET',
        responseType: 'blob',
        timeout: 120000
      }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          link.setAttribute('download', `${reportName}-${momentTz().tz(store.getters.getGeneralState('activePlant').timezone).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`);
          link.click();
          window.URL.revokeObjectURL(url);
      })
    },
  downloadPerformanceReport(param, reportName) {
    return Api().request({
      url: '/api/v2/advance-report/device/performance/' + param,
      method: 'GET',
      responseType: 'blob',
      timeout: 120000
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url

      link.setAttribute('download', `${reportName}-${momentTz().tz(store.getters.getGeneralState('activePlant').timezone).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`)
      link.click();
      window.URL.revokeObjectURL(url);
    })
  },
  downloadGenerationReport(param, reportName) {
    return Api().request({
      url: '/api/v2/advance-report/' + param,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${reportName}-${momentTz().tz(store.getters.getGeneralState('activePlant').timezone).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`)
      link.click();
      window.URL.revokeObjectURL(url);
    })
  }
}